import store from '@/store';

export default function Setup(axios) {
  axios.interceptors.request.use(
    config => {
      if (config.url !== '/login') {
        if (!config.headers.common.Authorization) {
          config.headers.common.Authorization = window.sessionStorage.getItem('token');
        }
      }
      return config;
    },
    error => Promise.reject(error));
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        store.dispatch('logout');
      }
      //return error.response;
      throw error;
    }
  );
}
